import type { I18nRecord } from '@/app/types';

// FAQ数据类型定义
export interface FaqItem {
  id: number;
  question: string;
  answer: string;
}

export const PRICING_FAQ: I18nRecord<FaqItem[]> = {
  china: {
    zh: [
      {
        id: 1,
        question: '什么是积分？',
        answer:
          '积分可用于生成视频，分为三种类型：\n1. 订阅积分：套餐内包含的积分额度，有效期 30 天。\n2. 购买积分：可按需额外购买的积分，有效期 2 年。\n3. 奖励积分：通过活动、比赛、艺术家计划等方式获得的额外积分奖励，有效期 2 年。',
      },
      {
        id: 2,
        question: '如何获取积分？',
        answer:
          '1. 注册赠送积分：新用户注册 Vidu 后，可获得体验积分。\n2. 订阅获取积分：可通过订阅服务获得更多积分。\n3. 每日登录获取积分：每日登录可获得积分。\n4. 参与活动获取积分：参与官方活动、比赛或艺术家计划，可获得额外积分奖励，详情可查看 Vidu 活动专区。',
      },
      {
        id: 3,
        question: '付费订阅套餐内积分用完了怎么办？',
        answer: '如果您的付费套餐订阅积分已用完，您可以在‘订阅-购买积分’找到增购积分入口。',
      },
      {
        id: 4,
        question: '购买积分规则',
        answer:
          '1. 积分购买服务仅对付费用户开放。\n2. 积分不可兑换会员，不可转赠，也不可提现。\n3. 积分充值有效期为2年，不支持退款或反向兑换为人民币。\n4. 积分消耗优先级：订阅套餐积分>增购积分。',
      },
      {
        id: 5,
        question: '是否能取消订阅？',
        answer: '我们很遗憾您决定取消 Vidu 订阅；\n若要进行取消，请在个人中心订阅页面-当前套餐页面-点击取消订阅。',
      },
      {
        id: 6,
        question: '是否能申请退款？',
        answer: '我们很遗憾无法提供退款，如有更多问题，请联系小助手邮箱：support@vidu.cn。',
      },
    ],
  },
  global: {
    en: [
      {
        id: 1,
        question: 'What are Credits?',
        answer:
          'Credits are used for video generation and come in three types:\n1. Subscription Credits: Credits included in your plan, valid for 30 days.\n2. Purchased Credits: Additional credits available for purchase on demand, valid for 2 years.\n3. Bonus Credits: Extra credits earned through events, competitions, or the Artist Program, valid for 2 years.',
      },
      {
        id: 2,
        question: 'How to Get Credits?',
        answer:
          '1. Sign-up Bonus: New users receive trial credits upon registering for Vidu.\n2. Subscription: Subscribe to a plan to receive more credits.\n3. Daily Login: Earn credits by logging in every day.\n4. Events & Activities: Participate in official events, competitions, or the Artist Program to earn bonus credits. Check the Vidu Events section for details.',
      },
      {
        id: 3,
        question: 'Will I Be Automatically Charged by Vidu?',
        answer:
          "If you've subscribed to Vidu through Stripe, your subscription will be automatically charged. Monthly plans charge every month, and annual plans charge every year.",
      },
      {
        id: 4,
        question: 'Can I Get a Refund?',
        answer:
          "We're sorry, but we are unable to provide refunds. If you need help canceling your subscription to prevent automatic charges, please contact the Vidu support team at support@vidu.com.",
      },
    ],
    zh: [
      {
        id: 1,
        question: '什么是积分？',
        answer:
          '积分可用于生成视频，分为三种类型：\n1. 订阅积分：套餐内包含的积分额度，有效期 30 天。\n2. 购买积分：可按需额外购买的积分，有效期 2 年。\n3. 奖励积分：通过活动、比赛、艺术家计划等方式获得的额外积分奖励，有效期 2 年。',
      },
      {
        id: 2,
        question: '如何获取积分？',
        answer:
          '1. 注册赠送积分：新用户注册 Vidu 后，可获得体验积分。\n2. 订阅获取积分：可通过订阅服务获得更多积分。\n3. 每日登录获取积分：每日登录可获得积分。\n4. 参与活动获取积分：参与官方活动、比赛或艺术家计划，可获得额外积分奖励，详情可查看 Vidu 活动专区。',
      },
      {
        id: 3,
        question: '购买积分规则',
        answer:
          '1. 积分购买服务仅对付费用户开放。\n2. 积分不可兑换会员，不可转赠，也不可提现。\n3. 积分充值有效期为2年，不支持退款或反向兑换为人民币。\n4. 积分消耗优先级：订阅套餐积分>增购积分。',
      },
      {
        id: 4,
        question: '是否能取消订阅？',
        answer:
          '我们很遗憾您决定取消 Vidu 订阅；\n若要进行取消，请在个人中心订阅页面-当前套餐页面-点击查看账单/修改支付方式，可以跳转stripe进行取消。',
      },
      {
        id: 5,
        question: '是否能申请退款？',
        answer: '我们很遗憾无法提供退款，如有更多问题，请联系邮箱：support@vidu.com。',
      },
    ],
    ja: [
      {
        id: 1,
        question: 'クレジットとは？',
        answer:
          'クレジットは動画生成に使用でき、3種類あります：\n1. サブスクリプションクレジット：プランに含まれるクレジット額で、有効期間は30日間です。\n2. 購入クレジット：必要に応じて追加購入できるクレジットで、有効期間は2年間です。\n3. ボーナスクレジット：イベント、コンテスト、アーティストプログラムなどで獲得できる追加クレジットで、有効期間は2年間です。',
      },
      {
        id: 2,
        question: 'クレジットの取得方法は？',
        answer:
          '1. 登録ボーナス：Viduに新規登録すると、体験用クレジットがもらえます。\n2. サブスクリプション：プランに加入するとより多くのクレジットを獲得できます。\n3. 毎日ログイン：毎日ログインするとクレジットを獲得できます。\n4. イベント参加：公式イベント、コンテスト、アーティストプログラムに参加するとボーナスクレジットを獲得できます。詳細はViduイベントセクションをご確認ください。',
      },
      {
        id: 3,
        question: '自動で支払われますか？',
        answer: 'Stripe経由で登録した場合、毎月または毎年、自動でお支払いが行われます。',
      },
      {
        id: 4,
        question: '返金はできますか？',
        answer:
          '申し訳ありませんが、返金は承っておりません。自動支払いを停止したい場合は、Viduサポート（support@vidu.com）までご連絡ください。',
      },
    ],
    de: [
      {
        id: 1,
        question: 'Was sind Credits?',
        answer:
          'Credits werden zur Videogenerierung verwendet und es gibt drei Typen:\n1. Abo-Credits: Im Plan enthaltene Credits, gültig für 30 Tage.\n2. Gekaufte Credits: Zusätzlich erwerbbare Credits, gültig für 2 Jahre.\n3. Bonus-Credits: Zusätzliche Credits durch Events, Wettbewerbe oder das Künstlerprogramm, gültig für 2 Jahre.',
      },
      {
        id: 2,
        question: 'Wie erhalte ich Credits?',
        answer:
          '1. Registrierungsbonus: Neue Nutzer erhalten bei der Anmeldung bei Vidu Test-Credits.\n2. Abonnement: Abonniere einen Plan, um mehr Credits zu erhalten.\n3. Tägliches Einloggen: Erhalte Credits durch tägliches Einloggen.\n4. Events & Aktivitäten: Nimm an offiziellen Events, Wettbewerben oder dem Künstlerprogramm teil, um Bonus-Credits zu erhalten. Details findest du im Vidu-Eventbereich.',
      },
      {
        id: 3,
        question: 'Wird mein Vidu-Abo automatisch abgebucht?',
        answer:
          'Wenn du dein Vidu-Abo über Stripe abgeschlossen hast, erfolgt die Abrechnung automatisch. Monatliche Abos werden jeden Monat, jährliche Abos einmal pro Jahr belastet.',
      },
      {
        id: 4,
        question: 'Kann ich eine Rückerstattung erhalten?',
        answer:
          'Leider können wir keine Rückerstattungen anbieten. Wenn du Hilfe beim Kündigen deines Abos brauchst, um automatische Abbuchungen zu vermeiden, wende dich bitte an unser Support-Team unter support@vidu.com.',
      },
    ],
    es: [
      {
        id: 1,
        question: '¿Qué son los créditos?',
        answer:
          'Los créditos se utilizan para generar vídeos y hay tres tipos:\n1. Créditos de suscripción: Créditos incluidos en tu plan, válidos durante 30 días.\n2. Créditos comprados: Créditos adicionales que puedes comprar según necesites, válidos durante 2 años.\n3. Créditos de bonificación: Créditos extra obtenidos a través de eventos, concursos o el Programa de Artistas, válidos durante 2 años.',
      },
      {
        id: 2,
        question: '¿Cómo obtener créditos?',
        answer:
          '1. Bonificación por registro: Los nuevos usuarios reciben créditos de prueba al registrarse en Vidu.\n2. Suscripción: Suscríbete a un plan para obtener más créditos.\n3. Inicio de sesión diario: Obtén créditos iniciando sesión cada día.\n4. Eventos y actividades: Participa en eventos oficiales, concursos o el Programa de Artistas para obtener créditos adicionales. Consulta la sección de eventos de Vidu para más detalles.',
      },
      {
        id: 3,
        question: '¿Vidu me cobrará automáticamente?',
        answer:
          'Si te has suscrito a Vidu a través de Stripe, tu suscripción se cobrará automáticamente. Los planes mensuales se cobran una vez al mes, mientras que los planes anuales se cobran una vez al año.',
      },
      {
        id: 4,
        question: '¿Podéis devolverme el dinero?',
        answer:
          'Lo sentimos, pero no podemos hacer devoluciones. Si necesitas ayuda para cancelar tu suscripción y evitar pagos automáticos, contacta con el equipo de atención al cliente de Vidu en support@vidu.com.',
      },
    ],
    fr: [
      {
        id: 1,
        question: 'Que sont les crédits ?',
        answer:
          "Les crédits sont utilisés pour la génération de vidéos et se déclinent en trois types :\n1. Crédits d'abonnement : Crédits inclus dans votre forfait, valables 30 jours.\n2. Crédits achetés : Crédits supplémentaires disponibles à l'achat selon vos besoins, valables 2 ans.\n3. Crédits bonus : Crédits supplémentaires obtenus via des événements, concours ou le Programme Artiste, valables 2 ans.",
      },
      {
        id: 2,
        question: 'Comment obtenir des crédits ?',
        answer:
          "1. Bonus d'inscription : Les nouveaux utilisateurs reçoivent des crédits d'essai lors de leur inscription sur Vidu.\n2. Abonnement : Abonnez-vous à un forfait pour recevoir plus de crédits.\n3. Connexion quotidienne : Gagnez des crédits en vous connectant chaque jour.\n4. Événements et activités : Participez aux événements officiels, concours ou au Programme Artiste pour obtenir des crédits bonus. Consultez la section Événements de Vidu pour plus de détails.",
      },
      {
        id: 3,
        question: 'Serai-je automatiquement facturé par Vidu ?',
        answer:
          'Si vous vous êtes abonné à Vidu via Stripe, votre abonnement sera automatiquement facturé. Les plans mensuels sont facturés chaque mois, et les plans annuels chaque année.',
      },
      {
        id: 4,
        question: 'Puis-je obtenir un remboursement ?',
        answer:
          "Nous sommes désolés, mais nous ne pouvons pas fournir des remboursements. Si vous avez besoin d'aide pour annuler votre abonnement afin d'éviter des frais automatiques, veuillez contacter l'équipe de support de Vidu à support@vidu.com.",
      },
    ],
    ko: [
      {
        id: 1,
        question: '크레딧이란 무엇인가요?',
        answer:
          '크레딧은 동영상 생성에 사용되며 세 가지 유형이 있습니다:\n1. 구독 크레딧: 플랜에 포함된 크레딧으로, 유효 기간은 30일입니다.\n2. 구매 크레딧: 필요에 따라 추가 구매할 수 있는 크레딧으로, 유효 기간은 2년입니다.\n3. 보너스 크레딧: 이벤트, 대회 또는 아티스트 프로그램을 통해 획득한 추가 크레딧으로, 유효 기간은 2년입니다.',
      },
      {
        id: 2,
        question: '크레딧을 어떻게 얻나요?',
        answer:
          '1. 가입 보너스: Vidu에 신규 가입하면 체험 크레딧을 받을 수 있습니다.\n2. 구독: 플랜을 구독하면 더 많은 크레딧을 받을 수 있습니다.\n3. 매일 로그인: 매일 로그인하면 크레딧을 받을 수 있습니다.\n4. 이벤트 참여: 공식 이벤트, 대회 또는 아티스트 프로그램에 참여하면 보너스 크레딧을 받을 수 있습니다. 자세한 내용은 Vidu 이벤트 섹션을 확인하세요.',
      },
      {
        id: 3,
        question: 'Vidu에서 요금이 자동으로 청구됩니까?',
        answer:
          'Stripe를 통해 Vidu에서 구독한 경우 구독 요금이 자동으로 청구됩니다. 월간 플랜은 매월 청구되며 연간 플랜은 매년 청구됩니다.',
      },
      {
        id: 4,
        question: '환불받으려면 어떻게 해야 합니까?',
        answer:
          '죄송하지만 환불은 지원되지 않습니다. 자동 청구를 방지하기 위해 구독을 취소하는 데 도움이 필요한 경우 Vidu 지원팀에 이메일(support@vidu.com)로 연락하세요.',
      },
    ],
    pt: [
      {
        id: 1,
        question: 'O que são créditos?',
        answer:
          'Os créditos são usados para gerar vídeos e existem três tipos:\n1. Créditos de assinatura: Créditos incluídos no seu plano, válidos por 30 dias.\n2. Créditos comprados: Créditos adicionais disponíveis para compra conforme a necessidade, válidos por 2 anos.\n3. Créditos bônus: Créditos extras obtidos por meio de eventos, competições ou do Programa de Artistas, válidos por 2 anos.',
      },
      {
        id: 2,
        question: 'Como obter créditos?',
        answer:
          '1. Bônus de cadastro: Novos usuários recebem créditos de teste ao se registrarem no Vidu.\n2. Assinatura: Assine um plano para receber mais créditos.\n3. Login diário: Ganhe créditos fazendo login todos os dias.\n4. Eventos e atividades: Participe de eventos oficiais, competições ou do Programa de Artistas para ganhar créditos bônus. Confira a seção de Eventos do Vidu para mais detalhes.',
      },
      {
        id: 3,
        question: 'Serei cobrado automaticamente pelo Vidu?',
        answer:
          'Se você assinou o Vidu por meio do Stripe, sua assinatura será cobrada automaticamente. Planos mensais são cobrados todo mês, e planos anuais são cobrados uma vez por ano.',
      },
      {
        id: 4,
        question: 'Posso pedir reembolso?',
        answer:
          'Lamentamos muito, mas não podemos oferecer reembolsos. Se você precisar de ajuda para cancelar sua assinatura e evitar cobranças automáticas, entre em contato com a equipe de suporte do Vidu em support@vidu.com.',
      },
    ],
    ru: [
      {
        id: 1,
        question: 'Что такое кредиты?',
        answer:
          'Кредиты используются для генерации видео и бывают трёх типов:\n1. Подписочные кредиты: Кредиты, включённые в ваш тариф, действительны 30 дней.\n2. Купленные кредиты: Дополнительные кредиты, которые можно приобрести по мере необходимости, действительны 2 года.\n3. Бонусные кредиты: Дополнительные кредиты, полученные через мероприятия, конкурсы или Программу для художников, действительны 2 года.',
      },
      {
        id: 2,
        question: 'Как получить кредиты?',
        answer:
          '1. Бонус за регистрацию: Новые пользователи получают пробные кредиты при регистрации в Vidu.\n2. Подписка: Оформите подписку на тариф, чтобы получить больше кредитов.\n3. Ежедневный вход: Получайте кредиты, заходя в систему каждый день.\n4. Мероприятия и активности: Участвуйте в официальных мероприятиях, конкурсах или Программе для художников, чтобы получить бонусные кредиты. Подробности — в разделе мероприятий Vidu.',
      },
      {
        id: 3,
        question: 'Будут ли автоматические списания?',
        answer:
          'При подписке через Stripe оплата продляется автоматически: ежемесячно для месячного тарифа и ежегодно для годового.',
      },
      {
        id: 4,
        question: 'Возможен ли возврат средств?',
        answer:
          'К сожалению, возврат средств не предусмотрен. Чтобы отменить автоматическое продление, обратитесь в поддержку Vidu: support@vidu.com.',
      },
    ],
  },
};

export const PRICING_FAQ_TITLE: I18nRecord<string> = {
  china: {
    zh: '常见问题',
  },
  global: {
    zh: '常见问题',
    en: 'Frequently Asked Questions',
    ja: 'よくある質問',
    de: 'Häufige Fragen',
    es: 'Preguntas frecuentes',
    fr: 'Questions Fréquemment Posées',
    ko: '자주 묻는 질문',
    pt: 'Perguntas Frequentes',
    ru: 'Часто задаваемые вопросы',
  },
};
